import { useEffect } from "react";

export const useInitialActions = (): void => {
	useEffect(() => {
		window && window.scrollTo(0, 0);
	}, []);
};
